export default __webpack_public_path__ + "static/InterDisplay-SemiBoldItalic-a931bc4a074fdba6c188ebd122326441.woff2";